import type { Session } from './auth'
import { gqlRequest } from './client'
import type { ApiMode } from './config'
import { MyRestaurantsQuery } from './operations'

export async function loginWithPersonalAccessToken(mode: ApiMode, value: string): Promise<Session> {
  const token = value.trim()
  if (!/^loco_pat_\S+$/.test(token)) throw new Error('Ange en giltig personlig åtkomsttoken.')

  const { me } = await gqlRequest({ mode, token }, MyRestaurantsQuery)
  if (!me?.id) throw new Error('Åtkomsttokenen kunde inte verifieras.')
  if (!me.restaurantsWithAccess?.some((restaurant) => restaurant.galleyEnabled === true)) {
    throw new Error('Åtkomsttokenen saknar åtkomst till en aktiverad köksskärm.')
  }

  // Keep the scoped PAT itself. The API enforces its expiry and revocation.
  return { mode, token, user: { id: me.id, name: me.name, username: me.username } }
}
